<div
    class="d-flex flex-row flex-wrap"
    dndDropzone
    dndHorizontal="true"
    dndEffectAllowed="copyMove"
    (dndDrop)="onDrop($event, activities)">
    <div class="activity placeholder" dndPlaceholderRef></div>
    @for (activity of activities; track activity) {
        <div
            cdkDropList
            matRipple
            dndEffectAllowed="copyMove"
            (dndCopied)="onDragged(activity, activities, 'copy')"
            (dndLinked)="onDragged(activity, activities, 'link')"
            (dndMoved)="onDragged(activity, activities, 'move')"
            (dndCanceled)="onDragged(activity, activities, 'none')"
            [dndDisableIf]="disableDragDrop"
            [dndDraggable]="activity"
            (cdkDropListDropped)="drop($event, activity)"
            (click)="selectActivity(activity)"
            class="activity curpoint"
            [class.selected]="selectedActivity?.id === activity.id"
            [class.d-none]="!!activity.executed && !showDoneActivities()">
            <div class="executed">
                <mat-checkbox
                    [disabled]="!(Functionalities.CustomerProjectsManage | hasFunctionality)"
                    (change)="execute($event, activity)"
                    [checked]="!!activity.executed"
                    color="primary">
                </mat-checkbox>
            </div>
            <div class="data">
                <div class="title">{{ activity.order }}. {{ activity.name }}</div>
                <div><b>Verantwoordelijke: </b> {{ activity.assignee }}</div>
                <div><b>Deadline: </b> {{ activity.deadline | date: 'd MMMM yyyy' }}</div>
            </div>
            <div class="edit">
                @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                    <button (click)="edit(activity)" color="primary" mat-icon-button>
                        <mat-icon class="fa fa-edit"></mat-icon>
                    </button>
                }
                <div>
                    @if ((projectReplies | filter: activity?.id : 'customer_projectphase_activity_id')?.length) {
                        {{ (projectReplies | filter: activity?.id : 'customer_projectphase_activity_id')?.length }}
                        <i class="fas fa-file"></i>
                    }
                </div>
            </div>
        </div>
    }
</div>
<div class="d-flex flex-row flex-wrap">
    <div class="activity">
        <div class="data">
            @if (selectedActivity) {
                <button mat-button color="primary" (click)="selectActivity(null)">Toon overige documenten</button>
            }
        </div>
    </div>
    @if (
        (Functionalities.GeoManage | hasFunctionality) || (Functionalities.CustomerProjectsManage | hasFunctionality)
    ) {
        <div [class.empty]="activities?.length < 1" class="activity add">
            <div class="data">
                <button (click)="edit()" color="primary" mat-button>
                    Activiteit toevoegen <img src="../../../assets/images/icons/customer-projects/add.svg" />
                </button>
            </div>
        </div>
    }
</div>
